import { getBillingTypeLabel } from "@constants";

export const capitalizeBillingTypeFirstLetter = (text) => {
  const billingTypeLabel = getBillingTypeLabel(text);
  if (billingTypeLabel) return billingTypeLabel;

  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
